import React from 'react'

import { Button } from 'slab'
import { type EmployersEmployee } from 'utils/web_api.schemas'

import { type MergeState } from './types'

interface MergeActionCellProps {
  duplicateEmployee: EmployersEmployee
  mergeStates: MergeState
  setMergeStates: React.Dispatch<React.SetStateAction<MergeState>>
  onMerge: (selectedEmployee: EmployersEmployee, duplicateEmployee: EmployersEmployee) => void
}

export const MergeActionCell = ({
  duplicateEmployee,
  mergeStates,
  setMergeStates,
  onMerge
}: MergeActionCellProps) => {
  const mergeState = mergeStates[duplicateEmployee.id]
  const selectedEmployee = mergeState?.selectedEmployee
  const isMerged = mergeState?.isMerged || false
  const isPending = mergeState?.isPending || false

  const handleMerge = () => {
    if (!selectedEmployee) return

    // Set pending state for this specific employee
    setMergeStates(prev => ({
      ...prev,
      [duplicateEmployee.id]: {
        ...prev[duplicateEmployee.id],
        isPending: true,
      },
    }))

    onMerge(selectedEmployee, duplicateEmployee)
  }

  if (isMerged) {
    return (
      <Button variant='primary' disabled>
        Matched
      </Button>
    )
  }

  return (
    <Button
      variant='primary'
      onClick={handleMerge}
      disabled={!selectedEmployee || isPending}
    >
      {isPending ? 'Matching...' : 'Match'}
    </Button>
  )
}
